import { render, staticRenderFns } from "./NewOrders.vue?vue&type=template&id=b23b4ce4&scoped=true&"
import script from "./NewOrders.vue?vue&type=script&lang=js&"
export * from "./NewOrders.vue?vue&type=script&lang=js&"
import style0 from "./NewOrders.vue?vue&type=style&index=0&id=b23b4ce4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23b4ce4",
  null
  
)

export default component.exports